import { MeRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import OSBrowserDetection from 'common/services/util/-RFC.OSBrowserDetection';
import Recaptcha from 'services/recaptcha';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$window', '$rootScope', 'Auth', 'Util',
    'UserRestService'];

/**
 * @ngdoc directive
 * @name directives.controller.twoFactorAuthController
 *
 * @description
 *  two factor authentication controller
 */

let _sendPhoneNumber;
let _recaptcha;
let _getPhoneNumber;

let _$scope;
let _user;
let _Util;
let _UserRestService;
let _sendPhoneNumberAlertSuccess;

class TwoFactorAuthController {

    /**
     * @param  {any} $scope
     * @param  {any} $window
     * @param  {any} $rootScope
     * @param  {any} Auth
     * @param  {any} Util
     * @param  {any} UserRestService
    */

    constructor(
        $scope, $window, $rootScope, Auth, Util,
        UserRestService,
    ) {

        _$scope = $scope;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.Auth = Auth;
        // _Util = Util;
        _Util = Util;
        // _UserRestService = UserRestService;
        _UserRestService = UserRestService;
        this.MeRepository = MeRepository;
        // _user = MeRepository.getMyUser();
        _user = MeRepository.getMyUser();

        _sendPhoneNumberAlertSuccess = this.sendPhoneNumberAlertSuccess;

        _$scope.tfaValidationStep = _user.attributes.status_tfa === 'active' ? 'tfaEnabled' : 'tfaDisabled';
        _$scope.selectedDevice = _$scope.selectedDevice || {};
        _$scope.disabledButton = false;
        _$scope.otp = {};
        this.otpError = false;
        _$scope.inputError = false;

        _$scope.logout = false;
        _$scope.brandName = CWCONFIG.partnerConfig.name;

        _$scope.Recaptcha = Recaptcha;

        _sendPhoneNumber = this.sendPhoneNumber;

        _$scope.setCaptchaResponse = this.setCaptchaResponse;
        _getPhoneNumber = this.getPhoneNumber;
        _recaptcha = Recaptcha;

        _$scope.onSubmitPhone = this.onSubmitPhone;
        _$scope.onSubmitResend = this.onSubmitResend;

        _$scope.showCaptcha = false;
        // MeRepository Observable
        const meRepositoryObservable = MeRepository.getObservable();
        const onNextMeRepository = () => {

            // get user from MeRepository
            _user = MeRepository.getMyUser();

        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(

            onNextMeRepository,
            () => { },
            () => { },
        );

        _$scope.goBackToCrypto = () => {

            $rootScope.isComingFromCrypto = false;

        };

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#twoStepValidationChanged
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * enable two factor authentication
     */
    enableTwoFactor() {

        Mixpanel.send('ConnectWeb 2FA Activate Click');

        _$scope.tfaValidationStep = 'tfaPhoneInput';

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#twoStepValidationChanged
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * disable two factor authentication
     */
    disableTwoFactor() {

        const phoneNumber = _getPhoneNumber();
        const payload = {
            data: {
                attributes: {
                    status_tfa: 'inactive',
                    phone_tfa: phoneNumber,
                },
                type: _user.type,
                id: _user.id,
            },
            meta: {
                tfa_attributes: {
                    browser: window.browserName,
                    os: window.deviceOs,
                },
            },
        };

        Mixpanel.send('ConnectWeb 2FA Deactivate Click');
        _$scope.disabledButton = true;

        _UserRestService.update(_user.id, payload).then((response) => {

            _$scope.disabledButton = false;

            // update User Repository - status_tfa & phone_tfa
            this.MeRepository.update(response.data.data);

            if (response.data.data.attributes.status_tfa === 'inactive') {

                Alert.success('cw.tfa.messages.deactivated');
                _$scope.tfaValidationStep = 'tfaDisabled';

            }

        }).then(null, () => {

            Alert.error();
            _$scope.disabledButton = false;

        });

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#sendSMS
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * by sending this command we receive the activation code via phone
     */
    sendPhoneNumber() {

        const headers = {};

        const captchaRespose = _recaptcha.getCaptchaResponse();

        if (captchaRespose) {

            headers['X-Avira-Captcha-Token'] = captchaRespose;

        }

        const phoneNumber = _getPhoneNumber();
        const payload = {
            data: {
                attributes: {
                    status_tfa: 'pending',
                    phone_tfa: phoneNumber,
                },
                type: _user.type,
                id: _user.id,
            },
        };

        const countryCode = _$scope.selectedDevice.country ?
            _$scope.selectedDevice.country.code.substring(0, 2) : '';

        // Check if the phone number is from international calling zone 1 and add to phoneNumber
        const isZoneOne = _$scope.selectedDevice.country.dialCode.indexOf('+1 ') > -1;
        const phoneNumberZoneOne = isZoneOne ?
            _$scope.selectedDevice.country.dialCode.substring(3).concat(_$scope.selectedDevice.phoneNumber) : '';

        const isValidNumber = isZoneOne ?
            _Util.isValidPhoneNumber(phoneNumberZoneOne, countryCode) :
            _Util.isValidPhoneNumber(_$scope.selectedDevice.phoneNumber, countryCode);

        if (isValidNumber) {

            _$scope.disabledButton = true;
            _$scope.showCaptcha = false;
            _recaptcha.reset();

            _UserRestService.update(_user.id, payload, headers).then((response) => {

                // Alert success
                _sendPhoneNumberAlertSuccess(phoneNumber);

                _$scope.disabledButton = false;
                _$scope.inputError = false;

                if (response.data.data.attributes.status_tfa === 'pending') {

                    _$scope.tfaValidationStep = 'tfaCodeInput';

                }

            }).then(null, () => {

                Alert.error();
                _$scope.disabledButton = false;

            });

        } else {

            _Util.triggerAnimation('.send-sms-inputs', 'animated shake');
            _$scope.inputError = true;
            _$scope.showCaptcha = false;
            _recaptcha.reset();

        }

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#sendPhoneNumberAlertSuccess
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * Notify the user that a code was sent to his phone number (ex: ******214)
     */
    sendPhoneNumberAlertSuccess(phoneNumber) {

        // last 3 digits of the phone number
        const phoneNumberlastDigits = phoneNumber.substr(phoneNumber.length - 3);

        Alert.success(
            { message: 'cw.notification.tfa.phoneNumber' },
            { message: { phoneNumber: phoneNumberlastDigits } },
        );

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#verifyCode
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * this command is sending the otp code to the backend in order to verify the phone number
     */
    sendOtpCode() {

        const phoneNumber = _getPhoneNumber();
        const osVersion = OSBrowserDetection.getOSVersion();
        const payload = {
            meta: {
                tfa_attributes: {
                    otp: _$scope.otp.code,
                    browser: this.$window.browserName,
                    os: osVersion,
                },
                logout: _$scope.logout,
            },
            data: {
                attributes: {
                    status_tfa: 'active',
                    phone_tfa: phoneNumber,
                },
                type: _user.type,
                id: _user.id,
            },
        };

        if (_$scope.otp.code) {

            _$scope.disabledButton = true;

            _UserRestService.update(_user.id, payload).then((response) => {

                Mixpanel.send('ConnectWeb 2FA Activate Success', {
                    Logout: _$scope.logout ? 'true' : 'false',
                });

                if (_$scope.logout === true) {

                    this.Auth.removeTfaCookie();
                    this.Auth.logOut();

                } else {

                    // update User Repository - status_tfa & phone_tfa
                    this.MeRepository.update(response.data.data);
                    Alert.success('cw.tfa.messages.activated');
                    this.Auth.removeTfaCookie();

                    _$scope.disabledButton = false;
                    _$scope.tfaValidationStep = 'tfaEnabled';
                    this.otpError = false;
                    _$scope.otp.code = '';

                }

            }).then(null, () => {

                _Util.triggerAnimation('.otp-code-input', 'animated shake');
                _$scope.disabledButton = false;
                this.otpError = true;

                // show custom error alert on too many attempts error
                if (this.$rootScope.errorMessage.indexOf('429') > -1) {

                    Alert.error('cw.notification.tfa.too_many_attempts');

                }

            });

        } else {

            this.otpError = true;
            _Util.triggerAnimation('.otp-code-input', 'animated shake');

        }

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#getPhoneNumber
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * get phone number
     */
    getPhoneNumber() {

        let phoneNumber = _user.attributes.phone_tfa || _user.attributes.phone;

        if (_$scope.selectedDevice.country) {

            phoneNumber = `${_$scope.selectedDevice.country.dialCode}${_$scope.selectedDevice.phoneNumber}`;

        }

        return phoneNumber;

    }

    /**
     * @ngdoc directive
     * @name directives.controller.twoFactorAuthController#toggleLogoutCheckbox
     * @methodOf directives.controller.twoFactorAuthController
     *
     * @description
     * toggle logout value
     */
    toggleLogoutCheckbox() {

        _$scope.logout = !_$scope.logout;

    }

    onSubmitPhone() {

        _$scope.showCaptcha = true;

    }

    setCaptchaResponse(response) {

        _recaptcha.setCaptchaResponse(response);
        const _sendPhoneNumberBind = _sendPhoneNumber.bind(this);
        _sendPhoneNumberBind();

    }

}

/**
 * @ngdoc directive
 * @name directives.twoFactorAuthDirective
 *
 * @description
 * change password directive
 */
class TwoFactorAuthDirective {

    constructor() {

        this.template = require('./two-factor-auth.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push((
            $scope, $window, $rootScope, Auth, Util,
            UserRestService,
        ) =>
            new TwoFactorAuthController(
                $scope, $window, $rootScope, Auth, Util,
                UserRestService,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'TwoFactorAuthCtrl';

    }

}

_directiveDependencies.push(() => new TwoFactorAuthDirective());


angular.module('directives')
    .directive('twoFactorAuth', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/security/two-factor-auth/two-factor-auth.js